import { Icon } from "@shared/components";
import { useIsSweepstakesExchangeEnabled } from "@shared/modules/sweepstakes/hooks/use-is-sweepstakes-enabled";
import React from "react";

import classes from "./style.module.css";

interface IProps {
  onClick: () => void;
}
export const BuyTimeButton: React.FC<IProps> = ({ onClick }) => {
  const isEnabled = useIsSweepstakesExchangeEnabled();

  if (!isEnabled) {
    return null;
  }

  return (
    <div className={classes.buyTimeButton} onClick={onClick}>
      <Icon name="clock" />
      <span> Buy time </span>
    </div>
  );
};
